import { render, staticRenderFns } from "./LoanAdvisoryListingCount.vue?vue&type=template&id=0aea66f8"
import script from "./LoanAdvisoryListingCount.vue?vue&type=script&lang=js"
export * from "./LoanAdvisoryListingCount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports